import {
	getDocumentStructureFolderItemsCount,
	getDocumentStructureFolderSize,
} from "@msuite/utils/documents";
import { getFileSizeString } from "@msuite/utils/strings";
import type { DocumentStructureFolderItem, Tables } from "@msuite/utils/types";
import { DataGrid } from "../../data-grid";
import { useTranslation } from "../../localization";

/** Props Interface */
interface FileExplorerPreviewFolderProps<T extends { file: Tables<"files"> }> {
	item: DocumentStructureFolderItem<T>;
}

export function FileExplorerPreviewFolder<T extends { file: Tables<"files"> }>({
	item,
}: FileExplorerPreviewFolderProps<T>) {
	/** Hooks */
	const { t } = useTranslation();

	const size = getDocumentStructureFolderSize(item);
	const count = getDocumentStructureFolderItemsCount(item);

	/** Render */
	return (
		<DataGrid>
			<DataGrid.Row>
				<DataGrid.Label>{t("files.folder_name")}</DataGrid.Label>
				<DataGrid.Cell>{item.name}</DataGrid.Cell>
			</DataGrid.Row>

			<DataGrid.Row>
				<DataGrid.Label>{t("files.full_path")}</DataGrid.Label>
				<DataGrid.Cell>{item.fullPath}</DataGrid.Cell>
			</DataGrid.Row>

			<DataGrid.Row>
				<DataGrid.Label>{t("files.folder_size")}</DataGrid.Label>
				<DataGrid.Cell>{getFileSizeString(size)}</DataGrid.Cell>
			</DataGrid.Row>

			<DataGrid.Row>
				<DataGrid.Label>{t("files.folders")}</DataGrid.Label>
				<DataGrid.Cell>{count.folders}</DataGrid.Cell>
			</DataGrid.Row>
			<DataGrid.Row>
				<DataGrid.Label>{t("files.files")}</DataGrid.Label>
				<DataGrid.Cell>{count.files}</DataGrid.Cell>
			</DataGrid.Row>
		</DataGrid>
	);
}
